<mat-select [(ngModel)]="participanteSeleccionado" (selectionChange)="seleccionarParticipante()">
    <mat-option *ngFor="let participante of participantesJson; let i = index" [value]="i">{{participante?.nombre}}</mat-option>
</mat-select>
